import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

@Injectable()
export class MapConfigService {

    private showPopups = false;
    private currentVehicleId?: number;

    private showPopupsChangeSubject: Subject<boolean> = new Subject<boolean>();
    private currentVehicleIdChangeSubject: Subject<any> = new Subject<any>();

    /**
     * pobranie flagi czy widoczen
     */
    public getShowPopupsFlag(): boolean {
        return this.showPopups;
    }
    public setShowPopupsFlag(flag: boolean): void {
        this.showPopups = flag;
        this.showPopupsChangeSubject.next(this.showPopups);
    }
    public showPopupsChange(): Observable<boolean> {
        return this.showPopupsChangeSubject.asObservable();
    }


    /**
     * pobranie biezacego pojazdu
     */
    public getCurrentVehicleId(): number {
        return this.currentVehicleId!;
    }
    public setCurrentVehicleId(source: string, vehicleId?: number): void {
      if (this.currentVehicleId != vehicleId) {
        this.currentVehicleId = vehicleId;
        this.currentVehicleIdChangeSubject.next({ currentVehicleId: this.currentVehicleId, source: source });
      }
    }
    public currentVehicleIdChange(): Observable<any> {
        return this.currentVehicleIdChangeSubject.asObservable();
    }

}
